import React, { Component } from "react";
import { Link } from 'react-router-dom'
import { shareFacebook, shareTwitter, shareWhatsapp, openNegishut } from "../Services/Sharing"

import "./HeaderArticle.scss"
import { handleLink } from "../Services/Storage";

class HeaderArticle extends Component {
  constructor() {
    super()
    this.handleLink = this.handleLink.bind(this);
    this.setShare = this.setShare.bind(this);
    this.state = {
      isSlided: false,
      isShareActive: false,
      linkBack: "/"
    }
  }
  componentDidMount() {
    const _linkBack = handleLink.get();
    if (_linkBack) {
      this.setState({
        linkBack: `?s=${_linkBack}`
      })
    }
  }
  setShare() {
    this.setState({
      isShareActive: !this.state.isShareActive
    })
  }
  handleLink() {
    const _linkBack = handleLink.get();
    window.location.href = _linkBack ? `./?s=${_linkBack}` : "./";
  }
  render() {
    return (
      <header>
        <div id="header" className="article">
          <div className="padding">
            <div className="container">
              <div className="publisher">
                <a href="https://ynet.co.il/" title="" target="_blank"><div className="logo"></div></a>
                <a href="" title="" target="_blank"><div className="sponslogo"></div></a>
                <a href="https://fb.me/poweredb" title="" target="_blank"><div className="pblogo"></div></a>
              </div>
              <div className="backtohomepage" onClick={this.handleLink}>
                <div className="text">
                  חזרה לעמוד הראשי
                </div>
                <div className="arrow"></div>
              </div>
              <div className="utils">
                <div className={`share${(this.state.isShareActive ? " active " : "")}`}>
                  <div onClick={this.setShare} className="sharer"></div>
                  <div onClick={() => { openNegishut() }} className="negishut"></div>
                  <div onClick={() => { shareFacebook() }} className="facebook"></div>
                  <div onClick={() => { shareTwitter() }} className="twitter"></div>
                  <div onClick={() => { shareWhatsapp() }} className="whatsapp"></div>
                </div>
              </div>
            </div>
          </div>
        </div>
        <div id="virtualHeader"></div>
      </header>
    );
  }
}

export default HeaderArticle;



// WEBPACK FOOTER //
// ./src/Components/Header/HeaderArticle.jsx